export default "__VITE_ASSET__DApqE32T__"